import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Col, Row, Tabs } from 'antd';

import { useTranslation } from 'react-i18next';
import UploadZone from '@/components/UploadZone';
import ButtonComponent from '@/components/Button';
import { notificationUtil } from '@/utils';

import '../index.scss';

function Payment({ onSubmit }) {
  const [slip, setSlip] = useState();
  const { t } = useTranslation();
  const onChangeFile = (file) => {
    setSlip(file);
  };

  const handleSubmit = () => {
    if (slip) {
      onSubmit(slip);
    } else {
      notificationUtil.alertError('MISSING_SLIP');
    }
  };

  const renderPaymentForm = () => (
    <>
      <Row gutter={[16, 24]}>
        <Col md={{ span: 12 }} span={24}>
          <div className="form-payment__bank">
            <span className="form-payment__bank__icon" />
            <div className="form-payment__bank__group">
              <p className="form-payment__bank__name">Kasikorn Bank</p>
              <p className="form-payment__bank__phone">
                153-2-94832-7
                <br />
                {t('common.banks.kasikorn.company_name')}
              </p>
            </div>
          </div>
        </Col>
        {/* <Col md={{ span: 12 }} span={24}>
          <div className="form-payment__bank">
            <span className="form-payment__bank__icon --kbank" />
            <div className="form-payment__bank__group">
              <p className="form-payment__bank__name">Krungthai Bank</p>
              <p className="form-payment__bank__phone">1924900334252</p>
            </div>
          </div>
        </Col> */}
      </Row>
      <div className="form-payment__upload">
        <h1 className="form-payment__upload__title">
          {t('subcribe_payment.upload_slip')}
        </h1>
        <UploadZone onChangeFile={onChangeFile} />
      </div>
      <div className="form-payment__buttons">
        <ButtonComponent
          className="form-payment__buttons__pay-later"
          onClick={() => onSubmit()}
        >
          {t('subcribe_payment.pay_later')}
        </ButtonComponent>
        <ButtonComponent
          type="primary"
          className="form-payment__buttons__submit"
          onClick={handleSubmit}
        >
          {t('subcribe_payment.submit')}
        </ButtonComponent>
      </div>
    </>
  );

  const items = [
    {
      key: '3',
      label: t('subcribe_payment.bank_transfer'),
      children: renderPaymentForm(),
    },
  ];

  return <Tabs defaultActiveKey="1" items={items} />;
}

Payment.propTypes = {
  onSubmit: PropTypes.func,
};

export default Payment;
